<template>
  <div v-if="priceDueToday">
    <span class="label-medium-bold text-static-success-hi">
      {{
        `${i18n.price(normalizePrice(priceDueToday))} ${i18n(translations.dueToday)}`
      }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './PriceDueToday.translations'

defineProps<{
  priceDueToday?: Price | null
}>()

const i18n = useI18n()
</script>
